import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { NomenclaturesApi } from '../../api'
import { QueryKeys } from './constants'

// TODO: fix types
interface UseNomenclaturesAvailableCountQueryProps {
    id?: number | string
    start?: Date | null
    end?: Date | null
}

export const useNomenclaturesAvailableCountQuery = (
    { id, start, end }: UseNomenclaturesAvailableCountQueryProps,
    options?: UseQueryOptions<number, Error>,
) => {
    const { data, error, isError, isLoading, isFetching, isSuccess, refetch, status } =
        useQuery<number, Error>({
            initialData: 0,
            queryKey: [
                QueryKeys.GetAllNomenclaturesAvailableCountQueryOptions,
                id,
            ],
            queryFn: () =>
                NomenclaturesApi.getNomenclaturesAvailableCount(
                    id!,
                    start!,
                    end!,
                ),
            ...(options ?? {}),
            enabled: !!id && !!start && !!end,
        })

    return {
        currentCount: data,
        error,
        status,
        refetch,
        isSuccess,
        isLoading,
        isError,
        isFetching,
    }
}
